import React from 'react';
//Componentes importados de material ui
import { Grid, ThemeProvider } from '@material-ui/core';
//Componentes comunes importados
import Input from '../input/Input';
import Select from '../selectAutocomplete/SelectAutocomplete';
//Fichero data importado
import { objAttributes, objText } from './DireccionGenericaData';
//Fichero style importado
import componenteDireccionGenericaStyle from './DireccionGenericaStyle';
//Sobreescritura de clases de material ui
import { overMiniInputs } from './DireccionGenericaStyle';
import { codigoPais } from 'AppData';


/**
 * @function DireccionGenerica
 * Función que contiene los campos necesarios para obtener una dirección completa
 * Contiene componentes Input y Select * 
 * @param {*} props 
 * Recibirá por parámetro a través de las props las propiedades options, getOptionsLabel, onInputChange e inputValue de los Select y el value y onChange de los Inputs
 */
export default function DireccionGenerica(props) {
    return (

        <Grid container direction='column'
            {...objAttributes.grids.direccionEncabezado}
            className={componenteDireccionGenericaStyle().classGridEncabezado}
        >
            <h3
                className={componenteDireccionGenericaStyle().classEncabezadoH3}
                {...objAttributes.titulos}
            >
                {props.titulo ? objText.titulo.interesado: objText.titulo.entidadRepresentada}
            </h3>
            <Grid container direction={props.isPhoneVersion ? 'column' : 'row'}
                {...objAttributes.grids.direccionContenerdor1}
                className={componenteDireccionGenericaStyle().classGridDireccionContenedor}
            >
                <Select /*TIPO VIA*/
                    {...props.attributesTipoVia}
                    {...objAttributes.selects.descripcionTipoViaDomicilio}
                    classes={componenteDireccionGenericaStyle()}
                    options={props.tipoViaOptions}
                    getOptionLabel={props.tipoViaGetOptionsLabel}
                    onChange={props.tipoViaOnChange}
                    value={props.tipoViaValue}
                    placeholder={objText.placeholder.descripcionTipoViaDomicilioInteresado}
                    noOptionsText={objText.noOptionsText}
                    inputRef={props.refDescripcionTipoViaDomicilio}
                    isRequired={true}
                />
                <Input /*NOMBRE VIA*/
                    {...props.attributesNombreVia}
                    {...objAttributes.inputs.nombreDomicilio}
                    classes={componenteDireccionGenericaStyle()}
                    value={props.nombreViaValue}
                    onChange={props.nombreViaOnChange}
                    placeholder={objText.placeholder.nombreDomicilioInteresado}
                    onBlur={props.nombreDomicilioInteresadoOnBlur}
                    inputRef={props.refNombreDomicilio}
                    isRequired={true}
                    autoComplete={'street-address'}
                />
            </Grid>
            <ThemeProvider theme={overMiniInputs}>{/*Se sobreescribe las classes de material ui aplicadas a los FormHelperText*/}
                <Grid container direction={props.isPhoneVersion ? 'column' : 'row'}
                    {...objAttributes.grids.direccionContenerdor2}
                    className={componenteDireccionGenericaStyle().classGridDireccionContenedor}
                >
                    <Grid container direction='row' className={componenteDireccionGenericaStyle().classGridBloque2Campos}>
                        <Input /*NUMERO*/
                            {...props.attributesNumero}
                            {...objAttributes.inputs.numeroDomicilio}
                            classes={componenteDireccionGenericaStyle()}
                            value={props.numeroValue}
                            onChange={props.numeroOnChange}
                            placeholder={objText.placeholder.numeroDomicilioInteresado}
                            onBlur={props.numeroDomicilioInteresadoOnBlur}
                            inputRef={props.refNumeroDomicilio}
                            autoComplete={'address-line1'}
                        />
                        <Input /*PISO*/
                            {...props.attributesPiso}
                            {...objAttributes.inputs.pisoDomicilio}
                            classes={componenteDireccionGenericaStyle()}
                            value={props.pisoValue}
                            onChange={props.pisoOnChange}
                            placeholder={objText.placeholder.pisoDomicilioInteresado}
                            onBlur={props.numeroPisoInteresadoOnBlur}
                            inputRef={props.refPisoDomicilio}
                            autoComplete={'address-line2'}
                        />
                    </Grid>
                    <Grid container direction='row' className={componenteDireccionGenericaStyle().classGridBloque2Campos}>
                        <Input /*PUERTA*/
                            {...props.attributesPuerta}
                            {...objAttributes.inputs.puertaDomicilio}
                            classes={componenteDireccionGenericaStyle()}
                            value={props.puertaValue}
                            onChange={props.puertaOnChange}
                            placeholder={objText.placeholder.puertaDomicilioInteresado}
                            autoComplete={'address-line3'}
                        />
                        <Input /*LETRA*/
                            {...props.attributesLetra}
                            {...objAttributes.inputs.letraDomicilio}
                            classes={componenteDireccionGenericaStyle()}
                            value={props.letraValue}
                            onChange={props.letraOnChange}
                            placeholder={objText.placeholder.letraDomicilioInteresado}
                            autoComplete={'address-line4'}
                        />
                    </Grid>
                    <Input /*ESCALERA*/
                        {...props.attributesEscalera}
                        {...objAttributes.inputs.escaleraDomicilio}
                        classes={componenteDireccionGenericaStyle()}
                        value={props.escaleraValue}
                        onChange={props.escaleraOnChange}
                        placeholder={objText.placeholder.escaleraDomicilioInteresado}
                        autoComplete={'address-line5'}
                    />
                </Grid>
            </ThemeProvider>
            <Grid container direction='column'
                {...objAttributes.grids.direccionContenerdor3}
                className={componenteDireccionGenericaStyle().classGridDireccionContenedor}
            >
                
                <Select /*PAIS*/
                    {...props.attributesPais}
                    {...objAttributes.selects.nombrePaisDomicilio}
                    classes={componenteDireccionGenericaStyle()}
                    options={props.paisesOptions}
                    getOptionLabel={props.paisesGetOptionLabel}
                    onChange={props.paisesOnChange}
                    value={props.paisesValue}
                    placeholder={objText.placeholder.nombrePaisDomicilioInteresado}
                    noOptionsText={objText.noOptionsText}
                    inputRef={props.refPais}
                    isRequired={true}
                />

                <Grid container direction={props.isPhoneVersion ? 'column' : 'row'}>
                    
                    <Select /*PROVINCIAS*/
                        {...props.attributesProvincias}
                        {...objAttributes.selects.nombreProvinciaDomicilio}
                        classes={componenteDireccionGenericaStyle()}
                        options={props.provinciasOptions}
                        getOptionLabel={props.provinciasGetOptionsLabel}
                        onChange={props.provinciasOnChange}
                        value={props.provinciasValue}
                        placeholder={objText.placeholder.nombreProvinciaDomicilioInteresado}
                        inputRef={props.refProvinciaDomicilio}
                        noOptionsText={objText.noOptionsText}
                        isRequired={true}
                        disabled={(props.paisesValue === null) || (props.paisesValue.codigo !== codigoPais.SPAIN)}
                    />
                    <Select /*MUNICIPIOS*/
                        {...props.attributesMunicipios}
                        {...objAttributes.selects.nombreMunicipioDomicilio}
                        classes={componenteDireccionGenericaStyle()}
                        options={props.municipiosOptions}
                        getOptionLabel={props.municipiosGetOptionsLabel}
                        onChange={props.municipiosOnChange}
                        value={props.municipiosValue}
                        placeholder={objText.placeholder.nombreMunicipioDomicilioInteresado}
                        noOptionsText={objText.noOptionsText}
                        refSelect={props.refSelect}
                        inputRef={props.refMunicipio}
                        isRequired={true}
                        disabled={(props.paisesValue === null) || (props.paisesValue.codigo !== codigoPais.SPAIN)}
                    />
                    <Input /*CODIGO POSTAL*/
                        {...props.attributesCodigoPostal}
                        {...objAttributes.inputs.codigoPostalDomicilio}
                        classes={componenteDireccionGenericaStyle()}
                        value={props.codigoPostalValue}
                        onChange={props.codigoPostalOnChange}
                        placeholder={objText.placeholder.codigoPostalDomicilioInteresado}
                        onBlur={props.codigoPostalOnBlur}
                        inputRef={props.refCodigoPostal}
                        isRequired={true}
                        autoComplete={'postal-code'}
                        disabled={(props.paisesValue === null) || (props.paisesValue.codigo !== codigoPais.SPAIN)}
                    />
                    
                </Grid>
            </Grid>
        </Grid>
    )
}